import script from "./SelectRecipients.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectRecipients.vue?vue&type=script&setup=true&lang=js"

import "./SelectRecipients.vue?vue&type=style&index=0&id=0890ab34&lang=css"

const __exports__ = script;

export default __exports__